/* Step 3 of the hair finder: lists every option that exists in the chosen length and adds the chosen one to the cart. */
(function () {
  'use strict';
  function init(root) {
    if (!root || root.dataset.hlrReady) return;
    root.dataset.hlrReady = '1';
    var cfg = JSON.parse(root.querySelector('[data-hlr-config]').textContent);
    var $ = function (s) { return root.querySelector(s); };
    var grid = $('[data-hlr-grid]'), msg = $('[data-hlr-msg]'), err = $('[data-hlr-error]');
    var title = $('[data-hlr-title]'), desc = $('[data-hlr-desc]');
    var pillTexture = $('[data-hlr-pill-texture]'), pillLength = $('[data-hlr-back]');
    var textureName = $('[data-hlr-texture-name]'), lengthName = $('[data-hlr-length-name]');
    var step2 = $('[data-hl-step="2"]');
    var designMode = !!(window.Shopify && Shopify.designMode);
    var params = new URLSearchParams(window.location.search);
    var handle = (params.get('collection') || '').trim();
    var lenParam = (params.get('length') || '').trim();
    var col = cfg.collections[handle];

    var fmt;
    try { fmt = new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cfg.currency }); }
    catch (e) { fmt = { format: function (n) { return n.toFixed(2); } }; }

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function norm(v) {
      var r = String(v).toLowerCase().replace(/inches|inch|"/g, '').trim();
      var n = parseFloat(r);
      return n > 0 ? String(n) : 's:' + String(v).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    }
    function showMessage(html) { msg.innerHTML = html; msg.hidden = false; }
    function setPills(lengthLabel) {
      if (col) { textureName.textContent = col.title; pillTexture.hidden = false; }
      if (col && lengthLabel) { lengthName.textContent = lengthLabel; pillLength.href = col.url; pillLength.hidden = false; }
    }

    /* Nothing chosen yet: this section steps aside so Step 1 can be shown. */
    if (!col) {
      if (!designMode) { root.hidden = true; root.style.display = 'none'; }
      else { title.textContent = cfg.chooseHeading; desc.textContent = cfg.chooseText; }
      return;
    }
    if (step2) step2.href = col.url;
    if (!lenParam) {
      title.textContent = col.title;
      desc.textContent = cfg.chooseLengthText;
      setPills('');
      showMessage('<a class="primary-btn" href="' + esc(col.url) + '">' + esc(cfg.chooseLengthButton) + '</a>');
      return;
    }

    var want = norm(lenParam);
    var label = /^[0-9.]+$/.test(lenParam) ? lenParam + cfg.unit : lenParam;
    title.textContent = cfg.headingTemplate.replace('{texture}', col.title).replace('{length}', label);
    desc.textContent = cfg.loadingText;
    setPills(label);
    grid.hidden = false;
    grid.innerHTML = '<div class="hlr__skeleton"></div><div class="hlr__skeleton"></div><div class="hlr__skeleton"></div>';

    function card(it) {
      var p = it.p, v = it.v;
      var img = (v.featured_image && v.featured_image.src) || (p.images && p.images[0] && p.images[0].src) || '';
      var src = img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=700' : '';
      var price = parseFloat(v.price), cmp = parseFloat(v.compare_at_price) || 0;
      var ok = v.available !== false;
      var url = '/products/' + p.handle + '?variant=' + v.id;
      var sub = v.title && v.title !== 'Default Title' ? v.title : '';
      return '<article class="hlr__card" data-variant="' + v.id + '">' +
        '<a class="hlr__media" href="' + url + '">' +
          (src ? '<img src="' + esc(src) + '" alt="' + esc(p.title) + '" loading="lazy" width="700" height="700">' : '') +
          (!ok ? '<span class="hlr__badge">' + esc(cfg.soldOutText) + '</span>' : '') +
          (sub ? '<span class="hlr__tag">' + esc(sub) + '</span>' : '') +
        '</a>' +
        '<div class="hlr__body">' +
          '<h3 class="hlr__name"><a href="' + url + '">' + esc(p.title) + '</a></h3>' +
          '<div class="hlr__price">' + (cmp > price ? '<s>' + fmt.format(cmp) + '</s>' : '') + '<span>' + fmt.format(price) + '</span></div>' +
          '<div class="hlr__actions">' +
            '<button type="button" class="primary-btn hlr__add" data-hlr-add data-variant="' + v.id + '"' + (ok ? '' : ' disabled') + '>' + esc(ok ? cfg.addText : cfg.soldOutText) + '</button>' +
            (cfg.showView ? '<a class="hlr__view" href="' + url + '">' + esc(cfg.viewText) + '</a>' : '') +
          '</div>' +
        '</div></article>';
    }

    function render(items) {
      grid.innerHTML = '';
      if (!items.length) {
        grid.hidden = true;
        desc.textContent = '';
        showMessage(esc(cfg.emptyText) + '<br><a class="primary-btn" href="' + esc(col.url) + '">' + esc(cfg.emptyButton) + '</a>');
        return;
      }
      var shown = String(items[0].val).toLowerCase();
      title.textContent = cfg.headingTemplate.replace('{texture}', col.title).replace('{length}', shown);
      desc.textContent = cfg.resultsText.replace('{count}', items.length);
      setPills(shown);
      grid.innerHTML = items.map(card).join('');
    }

    fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=250', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('bad'); return r.json(); })
      .then(function (d) {
        var items = [];
        (d.products || []).forEach(function (p) {
          var idx = -1;
          (p.options || []).forEach(function (o, i) {
            if (idx < 0 && String(o.name).toLowerCase().indexOf(cfg.option) > -1) idx = i;
          });
          if (idx < 0) return;
          (p.variants || []).forEach(function (v) {
            var val = v['option' + (idx + 1)];
            if (val != null && norm(val) === want) items.push({ p: p, v: v, val: val });
          });
        });
        render(items);
      })
      .catch(function () {
        grid.hidden = true;
        desc.textContent = '';
        showMessage(esc(cfg.errorText) + '<br><a class="primary-btn" href="' + esc(col.url) + '">' + esc(cfg.emptyButton) + '</a>');
      });

    grid.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-hlr-add]');
      if (btn && !btn.disabled) addToCart(btn);
    });

    function addToCart(btn) {
      var fd = new FormData();
      fd.append('id', btn.dataset.variant);
      fd.append('quantity', '1');
      var original = btn.textContent;
      err.hidden = true;
      btn.classList.add('is-loading');
      btn.textContent = cfg.addingText;
      fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) {
            err.textContent = res.body.description || res.body.message || cfg.errorText;
            err.hidden = false;
            btn.textContent = original;
            return;
          }
          var cardEl = btn.closest('.hlr__card');
          if (cardEl) cardEl.classList.add('is-added');
          btn.textContent = cfg.addedText;
          setTimeout(function () { btn.textContent = original; }, 2200);
          if (window.hnCart) { return window.hnCart.refresh().then(window.hnCart.open); }
          window.location = (window.routes && routes.cart_url) || '/cart';
        })
        .catch(function () {
          err.textContent = cfg.errorText;
          err.hidden = false;
          btn.textContent = original;
        })
        .then(function () { btn.classList.remove('is-loading'); });
    }
  }
  function boot() { document.querySelectorAll('[data-hlr]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();